import Model, { attr } from '@ember-data/model';

export enum ChannelCommissionChannel {
  bookingDotCom = 'booking_dot_com',
  homeAway = 'home_away',
  airbnbOfficial = 'airbnb_official',
  google = 'google',
  direct = 'direct',
}

export default class ChannelCommissionModel extends Model {
  @attr('number') amount!: number;
  @attr('string') channel!: ChannelCommissionChannel;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'channel-commission': ChannelCommissionModel;
  }
}
